<template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <app-form-text-input
                    label="Titulo"
                    v-model="message.name"
                    @input="$v.message.name.$touch()"
                    :required="true"
                    error-message="Debe diligenciar el titulo de la circular"
                    :has-error="$v.message.name.$error"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <label for=""
                    >Descripción
                    <span class="field-required-mark">*</span></label
                >
                <app-vue-editor
                    v-model="message.description"
                    @input="$v.message.description.$touch()"
                ></app-vue-editor>
                <div class="field-error" v-if="$v.message.description.$error">
                    Debe diligenciar la descripción de la circular
                </div>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col>
                <b-form-file
                    v-model="message.files"
                    placeholder="Seleccione los archivos que desea adjuntar"
                    drop-placeholder="Arrastre los archivos que desea adjuntar"
                    multiple
                ></b-form-file>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col>
                <app-sub-title text="Sedes" />
                <b-row v-for="venue in venues" :key="venue.id">
                    <b-col>
                        <b-form-checkbox
                            v-model="message.venues"
                            name="check-button"
                            switch
                            :value="venue.id"
                        >
                            {{ venue.name }}
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import brRepository from "../../../../repositories/broadcastMessages.repository";
import clientsRepository from "../../../../repositories/clients.repository";
import { required } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
export default {
    name: "broadcast_message_form",
    components: {
        appVueEditor: VueEditor
    },
    data: () => ({
        message: {
            name: "",
            description: "",
            venues: [],
            files: null
        },
        venues: []
    }),
    validations: {
        message: {
            name: { required },
            description: { required }
        }
    },
    methods: {
        async sendBroadcastMessage() {
            if (this.$v.$invalid)
                return (
                    toastr.error("Debe diligenciar los campos obligatorios") &&
                    this.$v.$touch()
                );

            if (!this.message.venues.length)
                return toastr.error("Debe seleccionar al menos una sede");

            const mr = { ...brRepository };

            // Construccion del payload
            const formData = new FormData();

            formData.append("userId", this.user.id);
            formData.append("clientId", this.client.id);
            formData.append("name", this.message.name);
            formData.append("description", this.message.description);

            this.message.venues.forEach(item =>
                formData.append("venues[]", item)
            );
            !!this.message.files &&
                this.message.files.forEach(item =>
                    formData.append("files[]", item)
                );

            try {
                const {
                    data: { msg, status, message }
                } = await mr.saveClientBroadcastMessage(formData);

                if (status) {
                    this.reset();
                    this.$emit("on-save", message);
                }

                return status ? toastr.success(msg) : toastr.error(msg);
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al guardar la circular [${this.getErrorMessage(
                        err
                    )}]`
                );
            } finally {
            }
        },
        reset() {
            this.$v.$reset();
            this.message.name = "";
            this.message.description = "";
            this.message.venues = [];
            this.message.files = null;
        },
        loadVenues() {
            const cr = { ...clientsRepository };

            cr.getVenuesByClient(this.client.id)
                .then(venues => (this.venues = venues))
                .catch(error =>
                    toastr.error(
                        "Ocurrió un error al cargar las sedes del cliente"
                    )
                );
        }
    },
    mounted() {
        this.loadVenues();
        if (this.venues.length === 1)
            this.message.venues.push(this.venues[0].id);
    },
    created() {
        this.$bus.$on(
            "client-broadcast-message-form.save",
            this.sendBroadcastMessage
        );
    },
    beforeDestroy() {
        this.$bus.$off("client-broadcast-message-form.save");
    }
};
</script>
